<template>
  <task-list-view type="todo" />
</template>

<script>
import TaskListView from './components/TaskListView.vue'

export default {
  name: 'WflowTodo',
  components: { TaskListView }
}
</script>
